<template>
  <div class="about">
    <section class="loooo" v-if="LOAD">
      <div class="loading">
        <p class="loading-text">Loading</p>
        <span class="dots"></span>
        <span class="dots"></span>
        <span class="dots"></span>
      </div>
    </section>
    <transition name="page2">
      <section v-if="!LOAD">
        <div class="image-box">
          <div class="logo">
            <span class="title">WhiteSpace</span>
          </div>
          <div class="imageI image1" :style="{backgroundImage : 'url(' + imgwall[0].src + ')'}" @click="openGallery(0)"></div>
          <div class="imageI image2" :style="{backgroundImage : 'url(' + imgwall[1].src + ')'}" @click="openGallery(1)"></div>
          <div class="imageI image3" :style="{backgroundImage : 'url(' + imgwall[2].src + ')'}" @click="openGallery(2)"></div>
        </div>
        <LightBox 
            :images="imgwall" 
            ref="lightbox"
            :show-caption="false"
            :show-light-box="false"
            :showThumbs="false"
        >
        </LightBox>
        <div class="content-box-2">
          <div class="col1">
            <span class="room-title-2">{{roomInfo.name}}</span>
            <span class="room-detail">
              房客人數限制： {{roomInfo.descriptionShort.GuestMin}}~{{roomInfo.descriptionShort.GuestMax}} 人 <br>
              床型：{{roomInfo.descriptionShort.Bed[0]}} <br>
              衛浴數量： {{roomInfo.descriptionShort['Private-Bath']}} 間 <br>
              房間大小： {{roomInfo.descriptionShort.Footage}} 平方公尺
            </span>
            <span class="room-descr">{{roomInfo.description}}</span>
            <div class="dec-box">
              <span class="dec"></span>
              <span class="dec"></span>
              <span class="dec"></span>
            </div>
            <div class="room-time">
              <div class="time-box">Check In<br><span>{{roomInfo.checkInAndOut.checkInEarly}} — {{roomInfo.checkInAndOut.checkInLate}}</span></div>
              <div class="time-box">Check Out<br><span>{{roomInfo.checkInAndOut.checkOut}}</span></div>
            </div>
            <div class="room-device">
              <div class="device" :class="{falseIcon:!roomInfo.amenities[item.title]}" :key="index" v-for="(item,index) in amenities">
                <img class="icon" :src="icons[index]">
                <span class="content">{{item.title}}</span>
              </div>
            </div>
          </div>
          <div class="col2">
            <div class="nor-price">NT.{{roomInfo.normalDayPrice}}</div>
            <div class="date-price">平日(一~四)</div>
            <div class="hoil-price">NT.{{roomInfo.holidayPrice}}</div>
            <div class="date-price">假日(五~日)</div>
          </div>
          <div class="col3">
            <div class="date-picker">
              <VueHotelDatepicker2
                :disabledDates="disabledDates"
                :fromText="'從'" :toText="'到'"
                :resetText="'重設'" :confirmText="'確認'"
                :weekList="['日', '一', '二', '三', '四', '五', '六']"
                :monthList="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
              />
              <div class="disable-block"></div>
            </div>
            <div class="submit" @click="bookingup=!bookingup"></div>
          </div>
        </div>
        <transition name="popup">
          <booking :currentRoomId='currentRoomId' v-on:childByValue="childByValue" v-if="bookingup"/>
        </transition>
        <Footer/>
      </section>
    </transition>
  </div>
</template>

<style lang="scss">
.about{
  position: relative;
  width: 100%;
  overflow: hidden;
  // height: 1560px;
}
.loooo{
  // position: absolute;
  top:0;
  left: 0;
  width: 100%;
  background-color: rgb(255, 255, 255);
  height: 600px;
  z-index: 100;
}
.loading{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  width: 50%;
  height: 10%;
  font-size: 24px;
  font-weight: 500;
  &-text{
    display: inline-block;
  }
  .dots{
    display: inline-block;
    visibility: hidden;
    width: 4px;
    height: 4px;
    background-color: #000;
    border-radius: 50%;
    margin-left: 12px;
    &:nth-child(2){
      animation:loadinganimation1 2s infinite;
    }
    &:nth-child(3){
      animation:loadinganimation2 2s infinite;
    }
    &:nth-child(4){
      animation:loadinganimation3 2s infinite;
    }
  }
}
section{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.logo{
  position: absolute;
  top: 5%;
  left: 5%;
  background-image: url(../assets/logo/logo-2.png);
  background-size: cover;
  background-position: 0 0;
  width: 168px;
  height: 54px;
  z-index: 10;
  .title{
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1px;
    position: absolute;
    right: 20px;
    bottom: 10px;
  }
}
.image-box{
  position: relative;
  width: 100%;
  padding-top: 50%;
  box-shadow: 0px 3px 8px 0 rgba(0, 0, 0, .2);
  .imageI{
    position: absolute;
    cursor: pointer;
    background-size: cover;
    background-position-y: bottom
  }
  .image1{
    top: 0;
    left: 0;
    width: 80%;
    height: 100%;
  }
  .image2{
    top:0;
    right: 0;
    width: 20%;
    height: 50%;
  }
  .image3{
    bottom: 0;
    right: 0;
    width: 20%;
    height: 50%;
  }
}
.content-box-2{
  width: 100%;
  // height: 800px;
  padding: 4% 5% 6% 5%;
  display: flex;
  justify-content: space-around;
  .col1{
    width: 40%;
  }
  .col2{
    text-align: right;
    width: 22%;
  }
  .col3{
    width: 32%;
  }
}
.room-title-2{
  display: block;
  font-size: 36px;
  font-weight: 500;
  letter-spacing: 1px;
}
.room-detail{
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 30px;
  margin-top: 30px;
  font-weight: 300;  
}
.room-descr{
  margin-top: 16px;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 20px;
}
.dec-box{
  margin-top: 15px;
  width: 100%;
  height: 10px;
  margin-bottom: 40px;
  .dec{
    width: 12px;
    height: 1px;
    background-color: #000;
    transform: rotate(45deg);
    margin-right: 6px;
  }
}
.room-time{
  width: 100%;
  .time-box{
    display: inline-block;
    width: 50%;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 1px;
    span{
      font-size: 21px;
    }
  }
}
.room-device{
  margin-top: 40px;
  width: 100%;
  padding: 0 30px 30px 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: #f0f0f0;
  .device{
    margin-top: 24px;
    width: 33.33%;
    display: flex;
    align-items: center;
    &.falseIcon{
      opacity: .3 ;
    }
  }
  .content{
    font-size: 12px;
    font-weight: 300;
  }
  .icon{
    width: 22px;
    height: 22px;
    margin-right: 16px;
  }
}
.nor-price{
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 1px;
}
.date-price{
  color: #6D7278 ;
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 1px;
}
.hoil-price{
  margin-top: 14px;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 1px;
}
.date-picker{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 394px;
}
.disable-block{
  position: absolute;
  z-index: 19;
  width: 100%;
  left: 0;
  top: 30%;
  height: 270px;
  background-color: transparent;
}
.submit{
  position: relative;
  margin-top: 24px;
  display: inline-block;
  width: 120px;
  height: 52px;
  cursor: pointer;
  &::before{
    content: '';
    position: absolute;
    background-image: url(../assets/logo/dec-black.png);
    background-size: contain;
    width: 100%;
    height: 100%;
    right: -6px;
    bottom: -8px;
  }
  &::after{
    content: '預約時段';
    position: absolute;
    background-color:  #575757;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: #fff;
    line-height: 52px;
    text-align: center;
  }
}
.popup-enter-active{
  transition: opacity 1s;
}
.popup-leave-active{
  transition: opacity .5s;
}
.popup-enter, .popup-leave-active{
  opacity: 0;
}
.page2-enter-active{
  transition: opacity 1s, transform 1s;
}
.page2-leave-active{
  opacity: 0;
}
.page2-enter{
  opacity: 0;
  transform: translateY(-100px);
}
@keyframes loadinganimation1 {
  0%{
    visibility: hidden;
  }
  20%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
@keyframes loadinganimation2 {
  0%{
    visibility: hidden;
  }
  50%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
@keyframes loadinganimation3 {
  0%{
    visibility: hidden;
  }
  80%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
</style>

<script>
// @ is an alias to /src
import booking from '@/components/booking.vue'

import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

import img0 from '../assets/icon2/wifi.svg'
import img1 from '../assets/icon2/breakfast.svg'
import img2 from '../assets/icon2/bar.svg'
import img3 from '../assets/icon2/ring.svg'
import img4 from '../assets/icon2/tv.svg'
import img5 from '../assets/icon2/breeze.svg'
import img6 from '../assets/icon2/fridge.svg'
import img7 from '../assets/icon2/weekend.svg'
import img8 from '../assets/icon2/mountain.svg'
import img9 from '../assets/icon2/smoke.svg'
import img10 from '../assets/icon2/crawling.svg'
import img11 from '../assets/icon2/dog.svg'

import VueHotelDatepicker2 from '@/components/VueHotelDatepicker2.vue'
import Footer from '@/components/Footer'

export default {
  name: 'about',
  components: {
    booking,
    LightBox,
    VueHotelDatepicker2,
    Footer,
  },
  data(){
    return{
      LOAD: true,
      currentRoomId : this.$route.query.roomId,
      bookingup : false,
      amenities: [
        {title:"Wi-Fi",ok:true},
        {title:"Breakfast",ok:false},
        {title:"Mini-Bar",ok:false},
        {title:"Room-Service",ok:true},
        {title:"Television",ok:true},
        {title:"Air-Conditioner",ok:false},
        {title:"Refrigerator",ok:true},
        {title:"Sofa",ok:true},
        {title:"Great-View",ok:false},
        {title:"Smoke-Free",ok:false},
        {title:"Child-Friendly",ok:true},
        {title:"Pet-Friendly",ok:false}
      ],
      icons: [
        img0,img1,img2,img3,img4,img5,img6,img7,img8,img9,img10,img11
      ]
    }
  },
  created(){
    this.LOAD = true
    this.$store.dispatch("getRoomInfo",{ roomId:this.currentRoomId })
  },
  computed:{
    roomInfo() {
      return this.$store.state.room
    },
    imgwall() {
      return this.$imgUrl.currentRoomImg(this.currentRoomId) //自訂方法，引入外部檔案的函式
    },
    disabledDates() {
      return this.$store.state.disabledDates
    }
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },
    childByValue(childValue){
      this.bookingup = childValue
    }
  },
  watch: {
    ['$store.state.room'](v,oldv){
        this.LOAD = false
    },
    deep:true  //因改變的是內部元素，所以要開 deep 才觀測得到
  }
}
</script>
